import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { WalletCardService } from "../../../../_services/_iam/wallet-card.service";
import { ErrorRedirectionService } from "../../../../_services/error-service/error-redirection.service";
import { saveAs } from 'file-saver';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: "app-onboarding-wallet-back",
  templateUrl: "./onboarding-wallet-back.component.html",
})
export class OnboardingWalletBackComponent {
  @Input() policyNumber: string;

  constructor(
    private walletCardService: WalletCardService,
    private cookieService: CookieService,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  createCookie(time, type): void {
    this.cookieService.set("walletcard", type, time);
  }

  downloadCard(policyNumber): void {
    this.walletCardService.generatePkPass(policyNumber).subscribe(
      (success) => {
        this.createCookie(365, "download");
        const blob = new Blob([success]);
        saveAs(blob, `${policyNumber}.pkpass`);
      },
      (error) => {
        if (error.status) {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
  }

}
